__turbopack_context__.v({
  "arrow": "nT-10G_arrow",
  "back": "nT-10G_back",
  "close": "nT-10G_close",
  "container": "nT-10G_container",
  "forward": "nT-10G_forward",
  "isDisabled": "nT-10G_isDisabled",
  "isFullscreen": "nT-10G_isFullscreen",
  "js-iv__trigger": "nT-10G_js-iv__trigger",
});
